import { ClusterService } from '@qdrant/qdrant-cloud-public-api/cluster/v1';
import { listQdrantReleases, getQdrantRelease } from '@qdrant/qdrant-cloud-public-api/cluster/v1/connect-query';
import { transport } from '@/api/transport';
import { createServiceQueries, queryOptions } from '@/connect-query';

export const databaseService = createServiceQueries(ClusterService, {
  getQdrantReleaseQuery: (params) => queryOptions(getQdrantRelease, params, { transport }),
  listQdrantReleasesQuery: (params) => queryOptions(listQdrantReleases, params, { transport, select: (d) => d.items }),
});
